// uiHost.tsx
import { Box, CssBaseline, Fade, ThemeProvider } from '@mui/material';
import { ensureRoot } from './ensureRoot';
import { state } from './state';
import { theme } from './theme';

export const renderHost = (open: boolean) => {
    ensureRoot().render(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Fade in={open} timeout={state.fadeMs} appear>
                {/* This Box ensures a stable mount point for Fade and lets overlays receive input */}
                <Box sx={{ position: 'fixed', inset: 0, pointerEvents: 'none' }}>
                    <Box sx={{ position: 'fixed', inset: 0, pointerEvents: 'auto' }}>
                        {state.current.kind === 'content' ? state.current.node : null}
                    </Box>
                </Box>
            </Fade>
        </ThemeProvider>,
    );
};
